// Format a date string (YYYY-MM-DD) to a localized date string without timezone conversion
export function formatDate(dateString: string | undefined | null): string {
  if (!dateString) return ''

  // Parse the date as local date (not UTC) to avoid timezone issues
  const [year, month, day] = dateString.split('-').map(Number)
  const date = new Date(year, month - 1, day) // month is 0-indexed

  return date.toLocaleDateString()
}

// Format a date string to YYYY-MM-DD for input fields
export function formatDateForInput(dateString: string | undefined | null): string {
  if (!dateString) return ''

  // If it's already in YYYY-MM-DD format, return as-is
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return dateString
  }

  // Otherwise parse and format
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}
